import { Link } from "react-router-dom";

export default function Inspiration() {
    return (
        <div style={{ height: "100%", width: "100%" }}>
            <header style={{ height: "10%", width: "100%", backgroundColor: "#111827", display: "flex", alignItems: "center", paddingLeft: "5%" }}>
                <Link to="/" style={{ display: "flex", height: "100%", width: "100%", flexDirection: "row", alignItems: "center", textDecoration: "none", WebkitTapHighlightColor: "transparent" }} >
                    <h1 style={{ color: "white", fontFamily: "'Quicksand', sans-serif" }}>Mem</h1>
                    <h1 style={{ color: "#c704a3", fontFamily: "'Quicksand', sans-serif" }}>Case</h1>
                </Link>

                <Link to="/editor" style={{ textDecoration: 'none', height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <button style={{ fontSize: ".75rem", fontFamily: "'Quicksand', sans-serif", boxShadow: "0 0 10px 2px #8b5cf6", height: "50%", backgroundColor: "#8b5cf6", color: "white", paddingLeft: "5%", paddingRight: "5%", border: "2px solid #8b5cf6", borderRadius: "10px" }}>
                        Create Your MemCase
                    </button>
                </Link>

            </header>
            <section style={{ height: "90%", width: "100%", backgroundColor: "black", display: "flex", flexDirection: "column" }}>



            </section>
        </div>
    )
}